import store from 'store'

import { oauthDomain } from 'domains/authentication/oauth'
import constants from 'config/constants'

const SERVICE_NAME = 'MCP'
const REDIRECT_PATHNAME = '/oauth/connect/'
const EXPIRY_MS = 4 * 60 * 1000

function removeMcpEntries() {
  store.each((_value: unknown, key: string) => {
    if (!key.startsWith(constants.oauth.noncePrefix)) {
      return
    }

    const nonce = key.substring(constants.oauth.noncePrefix.length + 1)
    const appState = oauthDomain.getAppState(nonce)

    if (appState.serviceName === SERVICE_NAME) {
      oauthDomain.deleteNonce(nonce)
    }
  })
}

export const mcpOauthPendingConnection = {
  save(externalAuthId: string, expiredAt?: number) {
    removeMcpEntries()
    const expiryMs = expiredAt === undefined ? EXPIRY_MS : expiredAt - Date.now()
    if (expiryMs <= 0) {
      return
    }
    oauthDomain.generateNonce(
      {
        serviceName: SERVICE_NAME,
        externalAuthId,
        redirectPathname: REDIRECT_PATHNAME,
      },
      expiryMs
    )
  },

  read(): { externalAuthId: string; expiredAt: number } | null {
    const match = oauthDomain.findValidNonceByServiceName(SERVICE_NAME)

    if (!match || match.appState.externalAuthId === undefined) {
      removeMcpEntries()
      return null
    }

    return {
      externalAuthId: match.appState.externalAuthId,
      expiredAt: match.appState.expiredAt,
    }
  },

  clear() {
    removeMcpEntries()
  },
}



// WEBPACK FOOTER //
// ./src/libs/mcpOauthPendingConnection/index.ts